'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDnd = require('react-dnd');

var _reactDndHtml5Backend = require('react-dnd-html5-backend');

var _reactDndHtml5Backend2 = _interopRequireDefault(_reactDndHtml5Backend);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _raf = require('raf');

var _raf2 = _interopRequireDefault(_raf);

var _Common = require('components/Common');

var _shallowequal = require('shallowequal');

var _shallowequal2 = _interopRequireDefault(_shallowequal);

var _Viewport = require('./Viewport');

var _ProjectScene = require('./ProjectScene');

var _ProjectScene2 = _interopRequireDefault(_ProjectScene);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* injects from baggage-loader */
var styles = require('./ProjectView.pcss');

var ProjectView = (_dec = (0, _reactDnd.DragDropContext)(_reactDndHtml5Backend2.default), _dec(_class = (0, _Viewport.windowDimensions)(_class = function (_Component) {
  _inherits(ProjectView, _Component);

  function ProjectView(props, context) {
    _classCallCheck(this, ProjectView);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ProjectView).call(this, props, context));

    if (props.previewingNode && props.previewingNodeId && props.data && props.data.nodesData) {
      var _props$data$nodesData = props.data.nodesData[props.previewingNodeId];
      var x = _props$data$nodesData.x;
      var y = _props$data$nodesData.y;

      _this.state = { viewportX: x, viewportY: y };
      return _possibleConstructorReturn(_this);
    }

    if (props.previewingProject || props.viewingProject) {
      var x = props.initSceneX || 0;
      var y = props.initSceneY || 0;
      _this.state = { viewportX: x, viewportY: y };
      return _possibleConstructorReturn(_this);
    }

    _this.state = {
      viewportX: props.initSceneX || 0,
      viewportY: props.initSceneY || 0
    };
    return _this;
  }

  _createClass(ProjectView, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setState({ showing: true });
    }
  }, {
    key: 'handleEdgeConnectionRequest',
    value: function handleEdgeConnectionRequest(fromId, toId) {
      this.props.onEdgeConnectionRequest(fromId, toId);
    }
  }, {
    key: 'handleEdgeRemove',
    value: function handleEdgeRemove(edgeId) {
      this.props.onEdgeRemove(edgeId);
    }
  }, {
    key: 'handleNodeRemove',
    value: function handleNodeRemove(id) {
      this.props.onNodeRemove(id);
    }
  }, {
    key: 'handleNodeDataUpdate',
    value: function handleNodeDataUpdate(id, data) {
      // TODO DE_BIND
      this.props.onNodeUpdate(id, data);
    }
  }, {
    key: 'handleNodesDataUpdate',
    value: function handleNodesDataUpdate(nodesIds, nodesData) {
      this.props.onNodesUpdate(nodesIds, nodesData);
    }
  }, {
    key: 'handleNodeDetach',
    value: function handleNodeDetach(id) {
      this.props.onNodeDetach(id);
    }
  }, {
    key: 'handleNodeAppendNew',
    value: function handleNodeAppendNew(id) {
      this.props.onNodeAppendNew(id);
    }
  }, {
    key: 'handleNodeAppendRightConnected',
    value: function handleNodeAppendRightConnected(id, _ref) {
      var x = _ref.x;
      var y = _ref.y;

      this.props.onNodeAppendRightConnected(id, { x: x, y: y });
    }
  }, {
    key: 'handleNodeAppendBottomConnected',
    value: function handleNodeAppendBottomConnected(id, _ref2) {
      var x = _ref2.x;
      var y = _ref2.y;

      this.props.onNodeAppendBottomConnected(id, { x: x, y: y });
    }
  }, {
    key: 'handleNodeAppendRight',
    value: function handleNodeAppendRight(id, _ref3) {
      var x = _ref3.x;
      var y = _ref3.y;

      this.props.onNodeAppendRight(id, { x: x, y: y });
    }
  }, {
    key: 'getViewportPosition',
    value: function getViewportPosition() {
      return this.refs.viewport.getPosition();
    }
  }, {
    key: 'handleNodePreview',
    value: function handleNodePreview(nodeId) {
      var _this2 = this;

      var nodesData = this.props.data.nodesData;
      var _nodesData$nodeId = nodesData[nodeId];
      var nodeX = _nodesData$nodeId.x;
      var nodeY = _nodesData$nodeId.y;

      this.props.onNodePreview(nodeId);
      this.props.onViewportPositionChange({ x: nodeX, y: nodeY });
      (0, _raf2.default)(function () {
        return _this2.setState({ viewportX: nodeX, viewportY: nodeY });
      });
    }
  }, {
    key: 'handlePositionChange',
    value: function handlePositionChange(_ref4) {
      var x = _ref4.x;
      var y = _ref4.y;

      this.setState({ viewportX: x, viewportY: y });
      this.props.onViewportPositionChange({ x: x, y: y });
    }
  }, {
    key: 'handleViewportPositionChange',
    value: function handleViewportPositionChange(pos) {
      this.handlePositionChange(pos);
    }
  }, {
    key: 'handleViewportDragStart',
    value: function handleViewportDragStart() {
      this.props.onViewportDragStart();
    }
  }, {
    key: 'handleViewportDragStop',
    value: function handleViewportDragStop() {
      this.props.onViewportDragStop();
    }
  }, {
    key: 'getScenePosition',
    value: function getScenePosition() {
      // shift the scene if previewing
      var _props = this.props;
      var previewingProject = _props.previewingProject;
      var viewingUser = _props.viewingUser;
      var previewingNode = _props.previewingNode;
      var previewingNodeId = _props.previewingNodeId;
      var viewingNode = _props.viewingNode;
      var windowWidth = _props.windowWidth;
      var nodesData = _props.data.nodesData;
      var _state = this.state;
      var viewportX = _state.viewportX;
      var viewportY = _state.viewportY;


      if (previewingNode && previewingNodeId || viewingNode) {
        var _nodesData$previewing = nodesData[previewingNodeId];
        var nodeX = _nodesData$previewing.x;
        var nodeY = _nodesData$previewing.y;

        return { x: Math.round(nodeX + windowWidth / 4), y: nodeY };
      }

      if (previewingProject || viewingUser) {
        var x = this.props.initSceneX || 0;
        var y = this.props.initSceneY || 0;

        return { x: x - windowWidth / 4, y: y };
      }

      return { x: viewportX, y: viewportY };
    }
  }, {
    key: 'isEmpty',
    value: function isEmpty() {
      var nodesData = this.props.data.nodesData;

      if ((0, _shallowequal2.default)(nodesData, {})) return true;
      if (!nodesData) return true;
      return false;
    }
  }, {
    key: 'getEmptyView',
    value: function getEmptyView() {
      var RemoveLink = _react2.default.createElement(
        _Common.PseudoLink,
        {
          onClick: this.props.onProjectDelete,
          danger: true
        },
        'remove the project'
      );
      return _react2.default.createElement(
        'div',
        { className: styles.emptyView },
        _react2.default.createElement(
          'div',
          { className: styles.caption },
          'You\'ve just deleted the last record in your project. Don\'t leave it like that.',
          _react2.default.createElement('br', null),
          'Click the button below to add something again or ',
          RemoveLink,
          '.'
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props;
      var data = _props2.data;
      var viewingProject = _props2.viewingProject;
      var previewingNode = _props2.previewingNode;
      var previewingNodeId = _props2.previewingNodeId;
      var previewingProject = _props2.previewingProject;
      var windowWidth = _props2.windowWidth;
      var windowHeight = _props2.windowHeight;
      var canPreviewNode = _props2.canPreviewNode;
      var disableModifications = _props2.disableModifications;
      var editNodesOnMount = _props2.editNodesOnMount;


      if (this.isEmpty()) return this.getEmptyView();

      var graph = data.graph;
      var nodesData = data.nodesData;


      var classname = (0, _classnames2.default)(styles.projectView, previewingNode && styles.previewingNode, previewingProject && styles.noPointerEvents);

      var _getScenePosition = this.getScenePosition();

      var x = _getScenePosition.x;
      var y = _getScenePosition.y;


      return _react2.default.createElement(
        'div',
        { className: classname },
        _react2.default.createElement(
          'div',
          {
            style: { width: windowWidth, height: windowHeight },
            className: styles.viewport
          },
          _react2.default.createElement(
            _Viewport.DraggableViewport,
            {
              ref: 'viewport',
              softWhenNotDragging: true,
              initSceneX: x, initSceneY: y,
              sendPositionChange: viewingProject,
              onDragStart: this.handleViewportDragStart.bind(this),
              onDragStop: this.handleViewportDragStop.bind(this),
              onPositionChange: this.handleViewportPositionChange.bind(this)
            },
            _react2.default.createElement(_ProjectScene2.default, {
              canPreviewNode: canPreviewNode,
              previewingNode: previewingNode,
              previewingNodeId: previewingNodeId,
              onNodeDataUpdate: this.handleNodeDataUpdate.bind(this),
              onNodesDataUpdate: this.handleNodesDataUpdate.bind(this),
              onNodeRemove: this.handleNodeRemove.bind(this),
              onEdgeRemove: this.handleEdgeRemove.bind(this),
              onNodePreview: this.handleNodePreview.bind(this),
              onNodeDetach: this.handleNodeDetach.bind(this),
              onNodeAppendNew: this.handleNodeAppendNew.bind(this),
              onNodeAppendRightConnected: this.handleNodeAppendRightConnected.bind(this),
              onNodeAppendBottomConnected: this.handleNodeAppendBottomConnected.bind(this),
              onNodeAppendRight: this.handleNodeAppendRight.bind(this),
              onEdgeConnectionRequest: this.handleEdgeConnectionRequest.bind(this),
              graphData: graph,
              nodesData: nodesData,
              disableModifications: disableModifications,
              editNodesOnMount: editNodesOnMount
            })
          )
        )
      );
    }
  }]);

  return ProjectView;
}(_react.Component)) || _class) || _class);
exports.default = ProjectView;


ProjectView.propTypes = {
  data: _react.PropTypes.object,

  onNodeUpdate: _react.PropTypes.func.isRequired,
  onNodesUpdate: _react.PropTypes.func.isRequired,
  onNodeRemove: _react.PropTypes.func.isRequired,
  onNodeDetach: _react.PropTypes.func.isRequired,
  onNodeAppendNew: _react.PropTypes.func.isRequired,
  onNodeAppendRight: _react.PropTypes.func.isRequired,
  onNodeAppendRightConnected: _react.PropTypes.func.isRequired,
  onNodeAppendBottomConnected: _react.PropTypes.func.isRequired,

  onEdgeRemove: _react.PropTypes.func.isRequired,
  onEdgeConnectionRequest: _react.PropTypes.func.isRequired,

  onProjectDelete: _react.PropTypes.func.isRequired,

  connectDropTarget: _react.PropTypes.func,
  isNodeOver: _react.PropTypes.bool,

  onViewportPositionChange: _react.PropTypes.func.isRequired,
  initSceneX: _react.PropTypes.number.isRequired,
  initSceneY: _react.PropTypes.number.isRequired,

  previewingProject: _react.PropTypes.bool,
  viewingUser: _react.PropTypes.bool,
  viewingNode: _react.PropTypes.bool,

  canPreviewNode: _react.PropTypes.bool,
  previewingNode: _react.PropTypes.bool,
  previewingNodeId: _react.PropTypes.string,

  disableModifications: _react.PropTypes.bool,
  editNodesOnMount: _react.PropTypes.bool,

  onViewportDragStart: _react.PropTypes.func.isRequired,
  onViewportDragStop: _react.PropTypes.func.isRequired,

  windowWidth: _react.PropTypes.number
};


//////////////////
// WEBPACK FOOTER
// ./app/components/Projects/ProjectView/ProjectView.js
// module id = 601
// module chunks = 1